/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HealthMonitorModule
 */

import { HealthMonitorHttp } from 'object-types';
import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';
import { IHealthMonitorHttpConfig } from '../healthmonitor.types';

/**
 * @description Health Monitor Http Config Item.
 * @author Rajawant Prajapati
 */
export class HealthMonitorHttpConfigItem extends MessageItem<IHealthMonitorHttpConfig> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: HealthMonitorHttp,
            ...args,
        };

        super(extendedArgs);
    }

    /**
     * Add ssl_attributes to the config if it doesn't exist.
     */
    public addSslAttributes(): void {
        if (!this.config.ssl_attributes) {
            this.setNewChildByField('ssl_attributes');
        }
    }
}
